module.exports = {"denied":false,"sex":null,"ethnicity":{"ethnicity":null,"origin":null,"description":null},"race":{"races":null,"native":{"tribe":null},"hawaiian":{"heritage":null,"description":null},"asian":{"heritage":null,"description":null}}}


//////////////////
// WEBPACK FOOTER
// ./src/components/profile/sections/tabs/demographics/resources/demographics.json
// module id = Ouw3
// module chunks = 1